export const apiUrl = process.env.VUE_APP_BASE_URL
export const serverUrl = process.env.VUE_APP_SERVER
export const frontendUrl = process.env.VUE_APP_URL_FRONTEND
export const echoKey = process.env.VUE_APP_ECHO_KEY
export const broadcaster = process.env.VUE_APP_BROADCASTER
export const cluster = process.env.VUE_APP_CLUSTER
export const forceTls = process.env.VUE_APP_FORCE_TLS
export const aesKey = process.env.VUE_APP_AES_KEY
export const aesIv = process.env.VUE_APP_AES_IV
export const appVersion = process.env.VUE_APP_VERSION